import { render, staticRenderFns } from "./BaseSplitButton.vue?vue&type=template&id=50c291d9&scoped=true"
import script from "./BaseSplitButton.vue?vue&type=script&lang=js"
export * from "./BaseSplitButton.vue?vue&type=script&lang=js"
import style0 from "./BaseSplitButton.vue?vue&type=style&index=0&id=50c291d9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50c291d9",
  null
  
)

export default component.exports